import { FormStep } from '../types'

export const enhancedFormSteps: FormStep[] = [
  {
    id: 'basic-info',
    title: 'Basic Information',
    description: 'Tell us your basic requirements to get personalized recommendations.',
    fields: [
      {
        name: 'gender',
        label: 'Gender',
        type: 'radio',
        required: true,
        defaultValue: 'male',
        options: [
          {
            value: 'male',
            label: "Men"
          },
          {
            value: 'female',
            label: "Women"
          }
        ]
      },
      {
        name: 'budget',
        label: 'Maximum Budget',
        type: 'range',
        required: true,
        min: 50,
        max: 300,
        step: 10,
        defaultValue: 150
      },
      {
        name: 'purpose',
        label: 'Primary Running Purpose',
        type: 'dropdown',
        required: true,
        defaultValue: 'daily-training',
        options: [
          {
            value: 'daily-training',
            label: 'Daily Training'
          },
          {
            value: 'racing',
            label: 'Racing/Competition'
          },
          {
            value: 'trail',
            label: 'Trail Running'
          },
          {
            value: 'casual',
            label: 'Casual/Lifestyle'
          }
        ]
      }
    ]
  },
  {
    id: 'preferences',
    title: 'Personal Preferences',
    description: 'Help us fine-tune your recommendations with optional preferences.',
    fields: [
      {
        name: 'footWidth',
        label: 'Foot Width',
        type: 'dropdown',
        required: false,
        defaultValue: 'medium',
        options: [
          {
            value: 'narrow',
            label: 'Narrow'
          },
          {
            value: 'medium',
            label: 'Medium'
          },
          {
            value: 'wide',
            label: 'Wide'
          },
          {
            value: 'x-wide',
            label: 'Extra Wide'
          }
        ]
      }
    ]
  }
]